<template>
  <div class="fullPage" ref="fullPage">
    <div class="showhover">
      <div v-for="it in sub" :key="it.key" @click.stop="toWhere(it.key)" class="hoveritem" :style="{color: showkey == it.key ?'#3170ff':''}">
        {{it.name}}
      </div>
    </div>
    <div class="fullPageContainer" ref="fullPageContainer">
      <div
        class="section bannerClass"
        :style="{ backgroundImage: `url(${imgUrl})` }"
      >
        <div class="main_content pt96" v-if="activeName == 'first'">
          <p class="title" style="width: 480px">
            单体楼宇管理场景
          </p>
          <img
            src="../../assets/line.png"
            alt=""
            class="title_line"
            style="width: 480px"
          />
          <p class="title2">MONOMER BUILDING</p>
          <div
            style="margin-top: 59px; font-family: 'Light';"
            class="banner_btn"
            @click="handleSelect('second')"
          >
            我要咨询
          </div>
        </div>

        <div class="main_content s2_content" v-if="activeName == 'second'">
          <div class="sub_title">
            <div class="div1 white">用户痛点</div>
            <div class="div2 white_gradient">USER PAIN POINT</div>
            <span class="line"></span>
          </div>
          <ul class="pain_point">
            <li
            class="width380"
              v-for="(item, index) in optionsArr"
              :key="index"
              :style="{
                backgroundImage: `url(${item.bg}`,
                backgroundPosition: 'center',
                backgroundSize: '100% 100%'
              }"
            >
              <img :src="item.icon" alt="" srcset="">
              <p class="p11">{{ item.title }}</p>
              <p class="p22">{{ item.str }}</p>
            </li>
          </ul>
        </div>

        <div class="main_content s2_content" v-if="activeName == 'third'">
          <div class="sub_title">
            <div class="div1 white">方案优势</div>
            <div class="div2 white_gradient">PLAN ADVANTAGE</div>
            <span class="line"></span>
          </div>
          <div class="plan_wrap">
            <img src="../../assets/user_plan.png" alt="" class="plan_img" />
          </div>

          <div class="plan_ul">
              <div class="leftArrow arrow">
                <i class="el-icon-back" @click="prevBtn1"></i>
              </div>
              <swiper
                height="50px"
                ref="mySwiper1"
                class="carousel"
                style="position: relative"
                :options="swiperOption1"
              >
                <swiper-slide
                  v-for="(item, index) in planArr"
                  :key="index"
                  class="carousel_title"
                >
                <p class="plan_title">{{ item.title }}</p>
                <p class="plan_str mt20">{{ item.str1 }}</p>
                </swiper-slide>
              </swiper>
              <div class="rightArrow arrow">
                <i class="el-icon-right" @click="nextBtn1"></i>
              </div>
            </div>
        </div>

        <div class="main_content s2_content" v-if="activeName == 'fourth'">
          <div class="sub_title">
            <div class="div1 white">客户价值</div>
            <div class="div2 white_gradient">CUSTOMER VALUE</div>
            <span class="line"></span>
          </div>
          <div class="value_wrap">
            <img src="../../assets/user_value.png" alt="" class="value_img" />
          </div>
        </div>

        <div class="main_content s2_content" v-if="activeName == 'five'">
          <div class="main_top">
            <div>
              <p class="title">
                落地案例
              </p>
              <img src="../../assets/line.png" alt="" class="s2_title_line" />
              <p class="title2">AFFILIATE CASE</p>
            </div>

            <div class="theSwiper">
              <div class="leftArrow arrow">
                <i class="el-icon-back" @click="prevBtn"></i>
              </div>
              <swiper
                height="50px"
                ref="mySwiper"
                class="carousel"
                style="position: relative"
                :options="swiperOption"
              >
                <swiper-slide
                  v-for="(item, index) in swiperArr"
                  :key="index"
                  @click="changeTitle(index)"
                  class="carousel_title"
                >
                  {{ item.title }}
                </swiper-slide>
              </swiper>
              <div class="rightArrow arrow">
                <i class="el-icon-right" @click="nextBtn"></i>
              </div>
            </div>
          </div>
          <div class="carousel_content">
            <div class="content_item">
              <img :src="currentItem.img" alt="" class="content_img" />
              <div class="content_wrap">
                <p class="content_title">{{ currentItem.title }}</p>
                <p
                  v-for="(descList, index1) in currentItem.desc"
                  :key="index1"
                  class="content_desc"
                >
                  {{ descList }}
                </p>
                <div
                  class="banner_btn mt20"
                  @click="handleUrl(currentItem.url)"
                >
                  了解更多
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="tabs">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="首页" name="first"> </el-tab-pane>
        <el-tab-pane label="用户痛点" name="second"></el-tab-pane>
        <el-tab-pane label="方案优势" name="third"></el-tab-pane>
        <el-tab-pane label="客户价值" name="fourth"></el-tab-pane>
        <el-tab-pane label="落地案例" name="five"></el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
import {prolist} from '../../untils/pro'

export default {
  name: "Service",
  components: {
    // 注册组件
    swiper,
    swiperSlide
  },
  data() {
    let that = this;
    return {
      showkey: 2,
      sub:[
          {name:'商业综合体能源管控解决方案',key:'1'},
          {name:'地下停车场智慧照明解决方案',key:'2'},
          {name:'空调分户计费解决方案',key:'3'},
          // {name:'文旅项目能源管控解决方案',key:'4'},
          // {name:'光储充能源管控解决方案',key:'5'},
          { name: "智慧园区解决方案", key: "6" },
        { name: "绿色校园解决方案", key: "7" },
        { name: "医院能效解决方案", key: "8" },
        ],
      swiperOption: {
        slidesPerView: 3, //一行显示3个
        spaceBetween: 20,
        initialSlide: 0, //默认第三页
        centeredSlides: true, //选中的swiper-slide显示在中间
        slideToClickedSlide: true, //可以点击切换
        speed: 1000, //滑动速度
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        },
        loop: true,
        autoplay: {
          delay: 1000,
          stopOnLastSlide: false,
          disableOnInteraction: false
        },
        on: {
          slideChangeTransitionStart() {
            let ix = null;
            // 3-0 4-1 5-2 6-3 7-4 8-5 9-6 10-0 11-1
            // 因为一次显示3个，前后都会补图片，形成闭环切换
            if (this.activeIndex === 3 || this.activeIndex === 10) {
              ix = 0;
            } else if (this.activeIndex === 4 || this.activeIndex === 11) {
              ix = 1;
            } else {
              ix = this.activeIndex - 3;
            }
            that.curIndex = ix;
            console.log(ix, "start");
          }
        }
      },
      swiperOption1: {
        slidesPerView: 3, //一行显示3个
        spaceBetween: 20,
        initialSlide: 0, //默认第三页
        centeredSlides: false, //选中的swiper-slide显示在中间
        slideToClickedSlide: true, //可以点击切换
        speed: 2000, //滑动速度
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        },
        loop: false,
        autoplay: false,
        on: {
          slideChangeTransitionStart() {
            let ix = null;
            // 3-0 4-1 5-2 6-3 7-4 8-5 9-6 10-0 11-1
            // 因为一次显示3个，前后都会补图片，形成闭环切换
            if (this.activeIndex === 3 || this.activeIndex === 10) {
              ix = 0;
            } else if (this.activeIndex === 4 || this.activeIndex === 11) {
              ix = 1;
            } else {
              ix = this.activeIndex - 3;
            }
          }
        }
      },
      activeName: "first",
      imgUrl: require("../../assets/service_bg1.png"),
      screenWidth: document.body.clientWidth,
      middle: 1,
      deviceData: [],
      simpleData: [],
      feedback: [],
      dbModelList: [],
      searchList: [],
      type: -1,
      expendStatus: false,
      productModel: "",
            optionsArr: [
        {
          bg: require("../../assets/pro/park/1.png"),
          icon: require('../../assets/pro/park/1111.png'),
          title: "能源管理需求复杂",
          str: "医院功能区众多，不同功能区能源管理具备精细化特点。"
        },
        {
          bg: require("../../assets/pro/park/2.png"),
          icon: require('../../assets/pro/park/2222.png'),
          title: "能源种类多",
          str: "医院用能主要包括电、天然气、水、可再生能源等。"
        },
        {
         bg: require("../../assets/pro/park/3.png"),
          icon: require('../../assets/pro/park/3333.png'),
          title: "连续供应要求高",
          str: "医院的特殊性，对能源系统连续供应要求较高。"
        },
        {
          bg: require("../../assets/pro/park/4.png"),
          icon: require('../../assets/pro/park/4444.png'),
          title: "环境控制要求高",
          str: "医院不同功能区对于无菌环境、温湿度要求高。"
        },
        {
         bg: require("../../assets/pro/park/1.png"),
          icon: require('../../assets/pro/park/5555.png'),
          title: "用能负荷不均",
          str: "医院常见部分负荷启动或局部能源供应的情况，大马拉小车现象普遍存在。"
        },
        {
          bg: require("../../assets/pro/park/2.png"),
          icon: require('../../assets/pro/park/6666.png'),
          title: "不同医院之间能耗差异很大",
          str: "受医院等级、类型、设备数量等影响，不同医院之间能耗差异很大。"
        }
      ],
      planArr: [
        {
          title: "能源数字化转型",
          str1: "全局掌控医院能源态势，打破各个子系统之间的信息孤岛，实现能源数字化转型。",
          str2: ""
        },
        {
          title: "运行成本降低",
          str1: "实施全成本核算，加强医院能耗管理，降低医院运行成本。",
          str2: ""
        },
        {
          title: "保障用能安全",
          str1: "对大型医疗设备的用电安全、用电质量进行监测，节能运行监测，提供真实可靠的数据支撑，保障用能安全。",
          str2: ""
        },
        {
          title: "云端服务",
          str1: "使用云端平台服务，无需购买服务器和系统软件，降低智能化系统的改造成本。",
          str2: ""
        }
      ],
      swiperArr: prolist,
      curIndex: 0,
      timer: 1000,
      AutoSwiper: null
    };
  },
  computed: {
    currentItem() {
      return this.swiperArr[this.curIndex];
    },
    swiper() {
      return this.$refs.mySwiper.swiper;
    },
    swiper1() {
      return this.$refs.mySwiper1.swiper;
    }
  },
  mounted() {
    this.activeName = this.$route.query.active;
    this.showkey = this.$route.query.showkey;
    if (this.activeName != "first") {
      this.imgUrl = require("../../assets/user_option_bg.png");
    }
  },
  methods: {
    prevBtn1() {
      this.swiper1.slidePrev();
    },
    nextBtn1() {
      this.swiper1.slideNext();
    },
    toWhere(key) {
      this.$router.push({
        path: `/service`,
        query: {
          showkey: key,
        },
      });
    },
    prevBtn() {
      this.swiper.slidePrev();
    },
    nextBtn() {
      this.swiper.slideNext();
    },
    handleUrl(url) {
      window.open(url, "_blank");
    },
    changeTitle(index) {
      this.curIndex = index;
    },
    handleSelect(num) {
      this.activeName = num;
    },
    handleClick(tab, event) {
      console.log(this.activeName)
      // 获取当前页面的URL
      let url = window.location.href,newurl = '';
      function replaceUrlParam(url, paramName, paramValue) {
        var urlObj = new URL(url);
        urlObj.searchParams.set(paramName, paramValue);
        return urlObj.toString();
      }
      newurl = replaceUrlParam(url,'active',this.activeName)
      window.location.href = newurl;
      if (this.activeName == "first") {
        this.$router.push({
          path: "/service",
          query: {
            showkey: this.showkey,
          },
        });
      } else {
        this.imgUrl = require("../../assets/user_option_bg.png");
      }
    }
  }
};
</script>

<style scoped lang="scss">
@import "../../assets/style/service.scss";

/*去掉el-tab-pane底部灰色线条*/
/deep/ .el-tabs__nav-wrap::after {
  height: 0 !important;
  background: transparent !important;
}
/*去掉el-tab-pane切换时的蓝色下划线*/
/deep/ .el-tabs__active-bar {
  background: transparent !important;
}

/deep/ .el-tabs__item.is-active {
  color: #3170ff;
}

/deep/ .el-tabs__nav {
  width: 100%;
  height: 60px;
  line-height: 60px;
  float: none;
  /* background: linear-gradient(90deg, rgba(52,56,59,0.99)); */
  background: linear-gradient(
    to right,
    rgba(0, 0, 0, 0.2) 0%,
    rgba(52, 56, 59, 0.2) 50%,
    rgba(0, 0, 0, 0.2) 100%
  );
  /* opacity: 0.6; */
}

/deep/ .el-tabs__item {
  padding: 0 35px;
  color: #ffffff;
  font-size: 14px;
  font-family: "Regular";
  opacity: 1 !important;
}

.bannerClass {
  width: 100%;
  color: #ffffff;
  background-image: url("../../assets/service_bg1.png");
  background-position: center;
  background-size: cover;
  position: relative;
}
.tabs {
  position: fixed;
  bottom: 20px;
  text-align: center;
  margin: auto;
  width: 100%;
}

.main_content {
  /* width: 1200px;
  margin: auto; */
  /* padding-top: 160px; */
  z-index: 99;
  text-align: left;
  .title {
    text-align-last: justify;
    font-size: 60px;
    font-family: "PangMenZhengDao";
    font-weight: 400;
    color: #ffffff;
    line-height: 1;
    letter-spacing: 6px;
  }
  .title_line {
    height: 8px;
    margin-top: 20px;
  }
  .title2 {
    font-size: 24px;
    font-family: "PangMenZhengDao";
    font-weight: 400;
    color: #ffffff;
    margin-top: 20px;
  }
  .banner_btn {
    width: 120px;
    height: 32px;
    line-height: 32px;
    background: rgba(0, 0, 0, 0);
    border: 1px solid #ffffff;
    color: #fff;
    border-radius: 16px;
    text-align: center;
    cursor: pointer;
    font-family: "Light";
  }
}

.content2 {
  background-image: url("../../assets/service_bg2.png");
  background-position: center;
  background-size: cover;
}

.content3 {
  background-image: url("../../assets/service_bg3.png");
  background-position: center;
  background-size: cover;
}

.content4 {
  background-image: url("../../assets/service_bg4.png");
  background-position: center;
  background-size: cover;
}
.content5 {
  background-image: url("../../assets/service_bg5.png");
  background-position: center;
  background-size: cover;
}

.sub_title {
  text-align: left;
  /* padding-top: 150px; */
  display: flex;
  align-items: baseline;
  .div1 {
    font-size: 60px;
    font-family: "PangMenZhengDao";
    font-weight: 400;
    letter-spacing: 4px;
  }
  .div2 {
    font-size: 24px;
    font-family: "PangMenZhengDao";
    font-weight: 400;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    margin-left: 24px;
  }
  .line {
    display: block;
    width: 5px;
    height: 16px;
    background: #3170ff;
    margin-left: 10px;
  }
}

.plan_wrap {
  align-items: center;
  display: flex;
  align-items: flex-start;
}
.plan_img {
  width: 778px;
  height: 368px;
  margin: auto;
  margin-top: 57px;
}

.plan_ul {
  display: flex;
  margin-top: 32px;

  li {
    width: 320px;
    height: 120px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    border-radius: 20px;
    padding: 0 20px;
    background: url("../../assets/light_li_bg.png") no-repeat;
    background-size: 100% 100%;
  }
  .plan_title {
    font-size: 18px;
    font-family: "Regular";
    font-weight: 400;
  }

  .plan_str {
    font-size: 14px;
    font-family: "Light";
    font-weight: 300;
    color: #ffffff;
    line-height: 20px;
  }
}

.value_wrap {
  align-items: center;
  display: flex;
  align-items: flex-start;
}
.value_img {
  width: 826px;
  height: 560px;
  margin-left: 160px;
  margin-top: 30px;
}


.main_top {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
}
.theSwiper {
  display: flex;
  .carousel {
    overflow: hidden;
    width: 650px;
    height: 50px;
  }
  .arrow {
    width: 40px;
    height: 50px;
    background: #232629;
    line-height: 50px;
    text-align: center;
    cursor: pointer;
  }
  .carousel_item {
    display: flex;
    /* position: relative; */
  }
  .carousel_wrapper {
    position: relative;
    height: 50px;
    padding: 0;
    left: 0;
  }
  .carousel_title {
    float: left;
    width: 180px;
    height: 50px;
    line-height: 50px;
    text-align: center;
    background: #262a2d;
    /* margin: 0 20px; */
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
  }
  >>>.swiper-slide-active {
    background: url("../../assets/aboutUs/item_bg.png") no-repeat;
    background-position: center;
    background-size: cover;
  }
}

.carousel_content {
  width: 100%;
  height: 400px;
  margin-top: 60px;
}
.content_item {
  display: flex;
  height: 400px;
}
.content_wrap {
  display: inline-flex;
  flex-direction: column;
  align-items: center;
}
.content_title {
  font-size: 16px;
  font-family: "Medium";
  font-weight: 500;
  color: #ffffff;
  line-height: 20px;
  text-align: center;
  margin-top: 58px;
}
.content_desc {
  font-size: 14px;
  font-family: "Regular";
  font-weight: 400;
  color: #ffffff;
  line-height: 22px;
  margin-top: 30px;
  text-indent: 28px;
  margin-left: 60px;
  margin-right: 60px;
}
.content_img {
  width: 800px;
  height: 400px;
}
.s2_title_wrap {
  padding-top: 136px;
}
.s2_content {
  padding-top: 80px;
}
</style>



// WEBPACK FOOTER //
// src/components/page/service_inlet8.vue